import { IrisCountryI } from '@iris/common/models/IrisCountry';
import { IrisGlobalSandbox } from '@iris/common/redux/global.sandbox';
import { IrisFilterDefaultChipItemViewComponent } from '@iris/modules/module-filters-v2/chips/default-chip-item-view.component';
import { isObject } from 'lodash';
import { map, shareReplay } from 'rxjs/operators';
import { IrisFilterChipRenderingOptions } from './chip-rendering-options';
import { ComponentRef } from '@angular/core';

type Country = IrisCountryI | IrisCountryI['id'];

export const COUNTRY_CHIP_RENDERING_OPTIONS: IrisFilterChipRenderingOptions<IrisFilterDefaultChipItemViewComponent, Country> = {
  component: IrisFilterDefaultChipItemViewComponent,
  initComponentFn: (componentRef: ComponentRef<IrisFilterDefaultChipItemViewComponent>, country, injector) => {
    const component = componentRef.instance;
    const service = injector.get(IrisGlobalSandbox);
    const id = isObject(country) ? country.id : country;

    component.text$ = service.countries$
      .pipe(
        map(countries => {
          const country = countries.find(country => country.id === id);
          return country?.nameTranslated || (country?.name ?? '');
        }),
        shareReplay({ bufferSize: 1, refCount: true }),
      );
  },
};
